import { makeAutoObservable } from 'mobx';
import { IBasePopup, IPopup } from '@context/global/typescript';

class PopupStore {
  private popupsArray: Array<IPopup> = [];

  constructor() {
    makeAutoObservable(this);
  }

  get popups(): Array<IPopup> {
    return this.popupsArray;
  }

  pushPopup = (singlePopup: IBasePopup) => {
    const maxPopupID = this.popupsArray.reduce((maxID, popup) => (popup.id > maxID ? popup.id : maxID), 0);

    this.popupsArray.push({
      ...singlePopup,
      id: maxPopupID + 1,
    });
  };

  removePopup = (id: number) => {
    this.popupsArray = this.popupsArray.filter((popup) => popup.id !== id);
  };
}

const popupStore = new PopupStore();
export default popupStore;
